import script from "./sidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./sidebar.vue?vue&type=script&setup=true&lang=js"

import "./sidebar.vue?vue&type=style&index=0&id=b3dab0b4&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Other\\EventMaster\\Dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3dab0b4"]])

export default __exports__